<template>
  <div class="form-row d-info d-frame">
    <h3>PLAYER <span v-if="playerWithoutTv">(bez reklam)</span><span v-if="playerWithTv">+ KANAŁY TV</span> - 30 dni</h3>
    <p><a href="#" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
     <p><strong>PLAYER (bez reklam)</strong> to najczęściej wybierany pakiet, idealny dla tych, którzy sięgają po rozrywkę bez ograniczeń. W pakiecie otrzymujesz pełny dostęp do produkcji Player Original oraz najnowszych odcinków ulubionych programów i seriali, a także kanału TVN na żywo. W pakiecie PLAYER (bez reklam) możesz oglądać wybrane materiały w jakości 4K i pobierać odcinki wybranych tytułów na urządzenia mobilne.</p>
      <p><strong>Biblioteka VOD i kanał TV</strong></p>
      <ul>
        <li>Brak reklam, możliwe przekazy autopromocyjne</li>
        <li>Pobieraj i oglądaj wybrane tytuły offline na urządzeniach mobilnych</li>
        <li>Wybrane programy w jakości UHD</li>
        <li>Najlepsze seriale i programy</li>
        <li>Kolekcje uznanych seriali Player Original</li>
        <li>Ekskluzywna kolekcja discovery+</li>
        <li>Bogata biblioteka wyjątkowych filmów</li>
        <li>Kanał TVN na żywo</li>
      </ul>

      <div v-if="playerWithTv">
      <p>LISTA KANAŁÓW W PAKIECIE PLAYER (BEZ REKLAM) + KANAŁY TV:</p>
      <p>TVN, TVN7, TTV, TVN24, TVN24 BiŚ, TVN Style, TVN Turbo, HGTV, TLC, Food Network, Travel Channel, Discovery, Discovery Life, Discovery Science, Discovery Historia, Animal Planet, DTX, Metro, Motowizja, Planete+, nSport+, CANAL+ Domo, CANAL+ Kuchnia, Investigation Discovery (ID), MiniMini+, TeleTOON+, AleKino+ </p>
      </div>

      <h3>Instrukcja użycia:</h3>
      <ul class="decimal">
        <li>Wpisz otrzymany kod na stronie <a href="https://player.pl/kod" target="_blank" rel="nofollow">player.pl/kod</a></li>
        <li>Zaloguj się lub załóż nowe konto w serwisie</li>
        <li>Zaznacz niezbędne zgody i aktywuj dostęp</li>
      </ul>
      <h3>Warunki korzystania:</h3>
      <div v-if="playerWithTv">
      <p>Do wykorzystania wyłącznie w serwisie player.pl do opłacenia pakietu PLAYER (bez reklam). Okres dostępu 30 dni od aktywacji.</p>
      </div>
      <p>
        <ol>
      <li>Administratorem platformy „Player.pl" jest TVN spółka akcyjna sp. j., zarejestrowaną zgodnie z prawem polskim pod numerem KRS 0000871610, z siedzibą przy ul. Wiertniczej 166, 02-952 Warszawa, Polska.</li>
      <li>Aby zrealizować Kod, musisz być zarejestrowanym i zalogowanym użytkownikiem Player.pl (skorzystaj z przycisku "Zaloguj się"). Jeśli nie masz konta w Player.pl, przed zrealizowaniem Kodu i uzyskaniem dostępu do usługi Player.pl, należy się zarejestrować (kliknij na "ZAŁÓŻ KONTO" w prawym górnym rogu strony) akceptując Regulamin Sklepu Player.pl oraz zapoznać się z Polityką Prywatności.</li>
      <li>Kod może być zrealizowany na stronie <a href="https://sklep.player.pl/moj-kod" target="_blank" rel="nofollow">https://sklep.player.pl/moj-kod</a> i nie może być wymieniony na żadne inne dostępy.</li>
      <li>Kod jest jednorazowy i niezbywalny i nie może być używany w połączeniu z żadnymi innymi kuponami rabatowymi, promocjami lub ofertami specjalnymi. Kod nie ma wartości pieniężnej, nie podlega zwrotowi i nie przysługuje za niego ekwiwalent pieniężny. Kod nie może być ponownie wykorzystany, nawet w przypadku zmiany lub anulowania subskrypcji. Niewłaściwe wykorzystanie Kodu, w tym jego upublicznienie lub sprzedaż, jest zabronione.</li>
      <li>Jeśli masz aktywną subskrypcję w Player.pl, sprawdź w <a href="https://player.pl/regulamin_sklepu_playerpl.pdf" target="_blank" rel="nofollow">Regulaminie Sklepu Player.pl</a>, w jakiej kolejności będą realizowane Twoje pakiety po zrealizowaniu Kodu.</li>
    </ol>
      <p><a href="#" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
import { PRODUCTS_CODES, PRODUCTS_CODES_VALUE } from '@/common/const/operators.const'

export default {
  name: 'TopupCodesInfoPlayer',
  props: ['amount'],
  data () {
    return {
      showMore: false
    }
  },
  computed: {
    playerWithoutTv: function () {
      return this.amount === PRODUCTS_CODES_VALUE[PRODUCTS_CODES.player][0].value
    },
    playerWithTv: function () {
      return this.amount === PRODUCTS_CODES_VALUE[PRODUCTS_CODES.player][1].value
    }
  }
}
</script>
